export enum ClipAvailabilityStatus {
  ALL_OK = 'ALL_OK',
  COMPOSITE_MP4_NOT_READY = 'COMPOSITE_MP4_NOT_READY',
  ALIGNED_STREAM_NOT_READY = 'ALIGNED_STREAM_NOT_READY',
  RECORDING_STUDIO_UNSUPPORTED_EVENT = 'RECORDING_STUDIO_UNSUPPORTED_EVENT',
  LIVE_EVENT_MIGRATION_IN_PROGRESS = 'LIVE_EVENT_MIGRATION_IN_PROGRESS'
}
